export const GET_HEALTH_DATA_REQUEST = "GET_HEALTH_DATA_REQUEST";
export const GET_HEALTH_DATA_SUCCESS = "GET_HEALTH_DATA_SUCCESS";
export const GET_HEALTH_DATA_FAILURE = "GET_HEALTH_DATA_FAILURE";
